export default "__VITE_ASSET__f97f2cb2__"